define([
	"dojo/_base/declare",
	"csi/table/AggregateFrom"
], function(declare,AggregateFrom) {

	return declare(AggregateFrom, {
		postProcessSuccess: function() {
			// Refresh Properties table to allow Freeze action
			var v = this.widget.viewParent.getChildView("Properties");
			if (v) {
				v.cacheView.put(this.getNode());
				v.refreshWidget();
			}

			this.inherited(arguments);
		}
	});
});
